export default "__VITE_ASSET__D_L8m1qJ__"